import _ from "lodash";
// Internal
import {
  getCustomAcademicCriteriaValues,
  getRating,
} from "../ratingPrimitives";

export const getPYPAndDPLocalGradeCriteriaSet = ({
  criteriaSet,
  ratings,
  subjectId,
  gradingPeriodType,
  termId,
  curriculumType,
}) => {
  // Get computed rating
  const computedRating = getRating({
    computedRating: true,
    ratings,
    overallGradeSet: criteriaSet,
    subjectId,
    categoryId: null,
    skipIsRemoved: true,
    gradingPeriodType,
    termId,
    curriculumType,
  });

  // Get overriding rating
  const overRidingRating = getRating({
    computedRating: false,
    ratings,
    overallGradeSet: criteriaSet,
    subjectId,
    categoryId: null,
    skipIsRemoved: true,
    gradingPeriodType,
    termId,
    curriculumType,
  });

  const value = _.get(computedRating, "value", "-");
  const valueId = _.get(computedRating, "academicCriteriaValue", "-");

  const overRidingValue = _.get(overRidingRating, "value", null);
  const overRidingRatingId = _.get(overRidingRating, "id", null);

  return {
    ...criteriaSet,
    value,
    valueId,
    overRidingValue,
    overRidingRatingId,
  };
};

export const getUBDLocalGradeCriteriaSet = ({
  criteriaSet,
  ratings,
  subjectId,
  gradingPeriodType,
  termId,
  curriculumType,
  academicCriteriaSets,
}) => {
  // Get computed rating
  const computedRating = getRating({
    computedRating: true,
    ratings,
    overallGradeSet: criteriaSet,
    subjectId,
    categoryId: null,
    skipIsRemoved: true,
    gradingPeriodType,
    termId,
    curriculumType,
  });

  // Get overriding rating
  const overRidingRating = getRating({
    computedRating: false,
    ratings,
    overallGradeSet: criteriaSet,
    subjectId,
    categoryId: null,
    skipIsRemoved: true,
    gradingPeriodType,
    termId,
    curriculumType,
  });

  const value = _.get(computedRating, "value", "-");
  const valueId = _.get(computedRating, "academicCriteriaValue", "-");

  const overRidingValue = _.get(overRidingRating, "value", null);
  const overRidingRatingId = _.get(overRidingRating, "id", null);

  // In UBD You can define custom values for a subject, grade and a term
  const customAcademicCriteriaValues = getCustomAcademicCriteriaValues({
    academicCriteriaSets,
    subjectId,
    curriculumType,
    termId,
    gradingPeriodType,
  });

  return {
    ...criteriaSet,
    value,
    valueId,
    overRidingValue,
    overRidingRatingId,
    customAcademicCriteriaValues,
  };
};

export const getMYPLocalGradeCriteriaSet = ({
  criteriaSet,
  ratings,
  subjectId,
  gradingPeriodType,
  termId,
  curriculumType,
  subjects,
  localGradeCalculationMethod,
  reportGradeId,
  uid,
}) => {
  // Get computed rating
  const computedRating = getRating({
    computedRating: true,
    ratings,
    overallGradeSet: criteriaSet,
    subjectId,
    categoryId: null,
    skipIsRemoved: true,
    gradingPeriodType,
    termId,
    curriculumType,
    localGradeCalculationMethod,
  });

  // Get overriding rating
  const overRidingRating = getRating({
    computedRating: false,
    ratings,
    overallGradeSet: criteriaSet,
    subjectId,
    categoryId: null,
    skipIsRemoved: true,
    gradingPeriodType,
    termId,
    curriculumType,
    localGradeCalculationMethod,
  });

  const value = _.get(computedRating, "value", "-");
  const valueId = _.get(computedRating, "academicCriteriaValue", "-");

  const overRidingValue = _.get(overRidingRating, "value", null);
  const overRidingRatingId = _.get(overRidingRating, "id", null);

  const currentSubjectData = _.get(subjects, subjectId, {});
  const gradeId =
    uid == "INTERDISCIPLINARY_GRADES"
      ? reportGradeId
      : currentSubjectData.gradeId;

  // In MYP when setting localGradeCalculationMethod is from MYP_FINAL_GRADE
  // Local grades are defined/different across grades
  const customAcademicCriteriaValues = getCustomAcademicCriteriaValues({
    criteriaSet,
    gradeId,
    curriculumType,
    localGradeCalculationMethod,
  });

  return {
    ...criteriaSet,
    value,
    valueId,
    overRidingValue,
    overRidingRatingId,
    customAcademicCriteriaValues,
  };
};
